import { endOfDay, getDay, isAfter, isBefore, parse, startOfDay, } from 'date-fns/esm';
import { TimetableOverrideType, } from '../types/TimeTable';
import { convertToSiteTz, datePickerWorldFormat } from './date';
import { isDefined } from './util';
export const isTimetableCurrentlyActive = (timetable, siteTz) => {
    // seems like this should be false - but default should actually be true, if
    // no timetable then normal setpoints are relevant. returning false causes
    // code to look at outside time table set points
    if (!isDefined(timetable) || !isDefined(siteTz)) {
        return true;
    }
    const now = new Date();
    const nowSiteTz = convertToSiteTz(now, siteTz);
    const convertToSiteDate = (d) => convertToSiteTz(d, siteTz);
    const isCurrentTimeDuringTimetable = timetable.rows.some(isTimeTableRowActive(nowSiteTz, now, convertToSiteDate));
    const isCurrentTimeDuringSpecialTimetable = timetable.specials.some(({ dateRanges, rows }) => {
        const takesPlaceDuringDateRange = isNowDuringDateRange(nowSiteTz, dateRanges);
        if (!takesPlaceDuringDateRange)
            return false;
        const isActive = rows.some(isTimeTableRowActive(nowSiteTz, now, convertToSiteDate));
        return isActive;
    });
    const isEitherActive = isCurrentTimeDuringTimetable || isCurrentTimeDuringSpecialTimetable;
    return isEitherActive;
};
const isTimeTableRowActive = (nowSiteTz, now, convertToSiteTz) => ({ begin, end, weekdays, overrideType }) => {
    const isScheduleActiveToday = isDateDayOfWeek(nowSiteTz, weekdays);
    if (!isScheduleActiveToday) {
        return false;
    }
    if (overrideType === TimetableOverrideType.ALWAYS_ON ||
        overrideType === TimetableOverrideType.ALWAYS_OFF) {
        return overrideType === TimetableOverrideType.ALWAYS_ON;
    }
    const isScheduleActive = isNormalEventCurrentlyHappening(now, begin, end, convertToSiteTz);
    return isScheduleActive;
};
var DayOfWeekMap;
(function (DayOfWeekMap) {
    DayOfWeekMap[DayOfWeekMap["SUN"] = 0] = "SUN";
    DayOfWeekMap[DayOfWeekMap["MON"] = 1] = "MON";
    DayOfWeekMap[DayOfWeekMap["TUE"] = 2] = "TUE";
    DayOfWeekMap[DayOfWeekMap["WED"] = 3] = "WED";
    DayOfWeekMap[DayOfWeekMap["THU"] = 4] = "THU";
    DayOfWeekMap[DayOfWeekMap["FRI"] = 5] = "FRI";
    DayOfWeekMap[DayOfWeekMap["SAT"] = 6] = "SAT";
})(DayOfWeekMap || (DayOfWeekMap = {}));
// Important that currentDate has been converted to site tz in case the site is
// in a different day than user
const isDateDayOfWeek = (currentDate, weekdays) => {
    const dayOfWeekIndex = getDay(currentDate);
    return weekdays.some((dayAbbreviation) => {
        return DayOfWeekMap[dayAbbreviation] === dayOfWeekIndex;
    });
};
const isNormalEventCurrentlyHappening = (now, begin, end, convertToSiteTz) => {
    //TODO: I NEED TO TAKE INTO ACCOUNT THE BIAS???? UGH
    let eventStartDateInUserTz, eventEndDateInUserTz;
    if (isDefined(begin.time)) {
        let time = parse(begin.time, 'kk:mm:ss', now);
        if (begin.time.substring(0, 2) === '00') {
            // date-fns parse returns an invalid date obj when passed '00:00:00'
            // apparently '24:00:00' is the correct thing to pass. and, yes,
            // '24:00:00' really does correspond to the start of the day while
            // '23:59:00' refers to 23 hours and 59 minutes later despite seeming like
            // they should parse to be just 1 minute apart
            time = parse(`24${begin.time.substring(2)}`, 'kk:mm:ss', now);
        }
        eventStartDateInUserTz = convertToSiteTz(time);
    }
    if (isDefined(end.time)) {
        let time = parse(end.time, 'kk:mm:ss', now);
        if (end.time.substring(0, 2) === '00') {
            time = parse(`24${end.time.substring(2)}`, 'kk:mm:ss', now);
        }
        eventEndDateInUserTz = convertToSiteTz(time);
    }
    let isCurrentTimeBetweenEvents = false;
    const isNowBetweenEventTimes = isDefined(eventStartDateInUserTz) &&
        isDefined(eventEndDateInUserTz) &&
        isAfter(now, eventStartDateInUserTz) &&
        isBefore(now, eventEndDateInUserTz);
    const isNowAfterStart = isDefined(eventStartDateInUserTz) &&
        !isDefined(eventEndDateInUserTz) &&
        isAfter(now, eventStartDateInUserTz);
    const isNowBeforeEnd = !isDefined(eventStartDateInUserTz) &&
        isDefined(eventEndDateInUserTz) &&
        isBefore(now, eventEndDateInUserTz);
    if (isNowBetweenEventTimes || isNowAfterStart || isNowBeforeEnd) {
        isCurrentTimeBetweenEvents = true;
    }
    return isCurrentTimeBetweenEvents;
};
const isNowDuringDateRange = (currentDate, dateRanges) => {
    const takesPlaceDuringDateRange = dateRanges.some(({ begin, end }) => {
        const beginDate = startOfDay(parse(begin, datePickerWorldFormat, currentDate));
        if (isBefore(currentDate, beginDate)) {
            // If before the beginning date, date range can't apply
            return false;
        }
        if (isDefined(end)) {
            const endDate = endOfDay(parse(end, datePickerWorldFormat, currentDate));
            return isBefore(currentDate, endDate);
        }
        else {
            // currently after the beginning and no end, so true
            return true;
        }
    });
    return takesPlaceDuringDateRange;
};
